import React from 'react';
import moment from 'moment';
import accounting from 'accounting';

import { Card, Table, Button, message } from 'antd'

import ProductSearch from './product-search';

import {
  _getExStockData,
  _postAddProductToExStock,
  _putRemoveProductFromExStock
} from '../../services'


class ProductExStock extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      productId: null,
      product: {},
      stockCount: null,
      supplier: {},
      salesData: [],
      customerData: []
    }
  }

  render() {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 6fr', columnGap: '8px'}}>
        {/* Product Search */}
        <Card title={false}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px'}}>
            <ProductSearch 
              onProductChange={this.onProductChange}/>
              <div style={{marginLeft: 'auto'}}>
                {this.renderButtons()}
              </div>
          </div>
        </Card>
        <div>
          {this.renderProductDetails()}
          {this.renderSupplierDetails()}
          <div style={{display: 'grid', gridTemplateColumns: '1fr 2fr', columnGap: '8px'}}>
            {this.renderSalesData()}
            {this.renderCustomerData()}
          </div>
        </div>
      </div>
    )
  }

  getData = () => {
    const { productId } = this.state

    _getExStockData({ productId })
    .then(data => {
      this.setState({
        product: data.data.product,
        stockCount: data.data.stockCount,
        supplier: data.data.supplier,
        salesData: data.data.salesData,
        customerData: data.data.customerData
      })
    })
  }

  renderButtons = () => {

    const { product } = this.state

    /* If already a ex stock item */
    if (product.exStock) {
      return (
        <Button
        onClick={this.confirmRemoveFromExStock}
        type='danger'>Remove From Ex Stock</Button>
      )
    }
      
    /* If not a ex stock item */
    return (
      <Button
        onClick={this.confirmAddToExStock}>Add To Ex Stock</Button>
    )
  }

  renderProductDetails = () => {

    const { product, stockCount } = this.state

    if (Object.keys(product).length === 0 ) { return null }

    return (
      <Card title={'Product Details'}>
        <div style={{display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 2fr 1fr 2fr'}}>

          <div><b>Id:</b></div>
          <div>{`${product._id}`}</div>

          <div><b>Title:</b></div>
          <div>{`${product.title}`}</div>

          <div><b>Main Cat:</b></div>
          <div>{`${product.categories.main}`}</div>

          <div><b>Sub Cat:</b></div>
          <div>{`${product.categories.sub}`}</div>

          <div><b>Brand:</b></div>
          <div>{`${product.brand.name}`}</div>

          <div><b>Stock:</b></div>
          <div>{`${stockCount}`}</div>


        </div>
      </Card>
    )
  }

  renderSupplierDetails = () => {

    const { supplier } = this.state

    if (Object.keys(supplier).length === 0 ) { return null }

    return (
      <Card title={'Supplier Details'}>
        <div style={{display: 'grid', gridTemplateColumns: '1fr 2fr 1fr 2fr 1fr 2fr'}}>

          <div><b>Id:</b></div>
          <div>{`${supplier._id}`}</div>

          <div><b>Email:</b></div>
          <div>{`${supplier.local.email}`}</div>

          <div><b>Company:</b></div>
          <div>{`${supplier.details.companyName}`}</div>

          <div><b>Address:</b></div>
          <div>{`${supplier.details.address}`}</div>

          <div><b>Hp:</b></div>
          <div>{`${supplier.details.hp}`}</div>

          <div><b>UEN:</b></div>
          <div>{`${supplier.details.uen}`}</div>

          <div><b>GST Registered:</b></div>
          <div>{`${supplier.details.gstRegistered}`}</div>


        </div>
      </Card>
    )

  }

  renderSalesData = () => {
     
    const { salesData } = this.state

    const columns = [{
      title: 'Month',
      dataIndex: 'date',
      render: (date) =>  moment(date).format('MMM YYYY')
    },{
      title: 'Count',
      dataIndex: 'count'
    },{
      title: 'Amount',
      dataIndex: 'amount',
      render: (amount) => accounting.formatMoney(amount, '$', 2)
    },{
      title: 'Quantity',
      dataIndex: 'quantity'
      }]

    return (
      <Card title={'Sales Data'}>
        <Table
          columns={columns}
          dataSource={salesData}
          size='small'
          pagination={false}
        />
      </Card>
    )
  }

  renderCustomerData = () => {

    const { customerData } = this.state

    const columns = [{
      title: 'Name',
      dataIndex: 'name',
    },{
      title: 'Amount',
      dataIndex: 'amount',
      render: (amount) => accounting.formatMoney(amount, '$', 2),
      sorter: (a, b) => a.amount - b.amount,
      defaultSortOrder: 'descend'
    },{
      title: 'Count',
      dataIndex: 'count',
      sorter: (a, b) => a.count - b.count,
    }]

    return (
      <Card title={'Customer Data'}>
        <Table
          columns={columns}
          dataSource={customerData}
          size='small'
          pagination={{
            pageSize: 20
          }}
        />
      </Card>
    )

  }

  onProductChange = (productId) => {
    this.setState({
      productId: productId
    }, this.getData)
  }

  confirmAddToExStock = () => {

    const { productId } = this.state 

    if (productId === '' || !productId) {
      message.error('No product selected!')
      return
    }

    _postAddProductToExStock({ productId })
    .then(data => {
      message.success(`${productId} successfully added to Ex Stock!`)
      this.getData()
    })

  }

  confirmRemoveFromExStock = () => {

    const { productId } = this.state 

    if (productId === '' || !productId) {
      message.error('No product selected!')
      return
    }

    _putRemoveProductFromExStock({ productId })
    .then(data => {
      message.success(`${productId} successfully removed from Ex Stock!`)
      this.getData()
    })

  }
}

export default ProductExStock;


// WEBPACK FOOTER //
// ./src/components/product-ex-stock/index.js